/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WebApiCustomListsDtoChangeCustomListItemMembersDto
 */
export interface WebApiCustomListsDtoChangeCustomListItemMembersDto {
    /**
     * 
     * @type {number}
     * @memberof WebApiCustomListsDtoChangeCustomListItemMembersDto
     */
    customListId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WebApiCustomListsDtoChangeCustomListItemMembersDto
     */
    memberIds?: Array<number> | null;
}

/**
 * Check if a given object implements the WebApiCustomListsDtoChangeCustomListItemMembersDto interface.
 */
export function instanceOfWebApiCustomListsDtoChangeCustomListItemMembersDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiCustomListsDtoChangeCustomListItemMembersDtoFromJSON(json: any): WebApiCustomListsDtoChangeCustomListItemMembersDto {
    return WebApiCustomListsDtoChangeCustomListItemMembersDtoFromJSONTyped(json, false);
}

export function WebApiCustomListsDtoChangeCustomListItemMembersDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiCustomListsDtoChangeCustomListItemMembersDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customListId': !exists(json, 'customListId') ? undefined : json['customListId'],
        'memberIds': !exists(json, 'memberIds') ? undefined : json['memberIds'],
    };
}

export function WebApiCustomListsDtoChangeCustomListItemMembersDtoToJSON(value?: WebApiCustomListsDtoChangeCustomListItemMembersDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'customListId': value.customListId,
        'memberIds': value.memberIds,
    };
}

